import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { useDispatch, useSelector } from 'react-redux';
import _ from 'lodash';
import { toast } from 'react-toastify';
import Modal from '../../../../_common/Modal/Modal';
import classes from './create_person.module.scss';
import AssigneeSelect from '../../PossiblePersonsComponent/AssigneeSelect';
import SelectWithSearch from '../../../../_common/Form/Selects/SelectWithSearch/SelectWithSearch';
import { getHealthRequest } from '../../../../../store/actions/healths';
import accountHelpers from '../../../../../utils/accountHelpers';
import Select from '../../../../_common/Form/Selects/Select/Select';
import InputField from '../../../../_common/Form/TextFields/InputField';
import Button from '../../../../_common/Form/Buttons/Button';
import utils from '../../../../../utils/utils';
import { personStatusPosition } from '../../../../../utils/data/data';
import DOBPicker from '../../../../_common/Form/DatePickers/DOBPicker/DOBPicker';
import { createPersonsRequest } from '../../../../../store/actions/possiblePersons';

const createPersonTemplate = [
  {
    label: 'Hub id',
    path: 'hub',
  },
  {
    label: 'Phone',
    path: 'phone',
  },
  {
    label: 'Email',
    path: 'email',
  },
  {
    label: 'DOB',
    path: 'dob',
  },
  {
    label: 'Street',
    path: 'addressStreet',
  },
  {
    label: 'City',
    path: 'addressCity',
  },
];

const CreatePersonModal = ({
  open,
  onClose,
}) => {
  let count = 7;

  const dispatch = useDispatch();
  const { healthList } = useSelector((store) => store.healths);
  const [requestData, setRequestData] = useState({
    firstName: '',
    lastName: '',
    phone: '',
    email: '',
    addressStreet: '',
    addressCity: '',
    addressState: '',
    addressZipCode: '',
    hub: '',
    dob: '',
    healthPlanId: '',
    userId: '',
    status: 0,
  });
  const [hoverStatus, setHoverStatus] = useState(undefined);
  const [searchHeath, setSearchHeath] = useState('');
  const [searchLoading, setSearchLoading] = useState(false);
  const [saveLoading, setSaveLoading] = useState(false);
  const [requestError, setRequestError] = useState({});

  const {
    firstName,
    lastName,
    addressState,
    addressZipCode,
    userId,
    status,
  } = requestData;

  const onChangeHeathSearch = async (value) => {
    setSearchLoading(true);
    setSearchHeath(value);
    await dispatch(getHealthRequest({
      userId: accountHelpers.getUser().id,
      page: 1,
      name: value,
    }));
    setSearchLoading(false);
  };

  const onKeyPress = (e, validationType, isPaste) => {
    if (validationType === 'phone') {
      utils.keyPressPhoneNumber(e, isPaste);
    }
  };

  const onChangeData = (path, value, searchValue) => {
    if (path !== 'hub') {
      setRequestError((prev) => ({
        ...prev,
        [path]: '',
      }));

      setRequestData((prev) => {
        if (path === 'healthPlanId') {
          setSearchHeath(searchValue);
          return {
            ...prev,
            [path]: value,
            hub: searchValue,
          };
        }
        return {
          ...prev,
          [path]: value,
        };
      });
    }
  };

  const closeModal = () => {
    setSearchHeath('');
    setRequestData({
      firstName: '',
      lastName: '',
      phone: '',
      email: '',
      addressStreet: '',
      addressCity: '',
      addressState: '',
      addressZipCode: '',
      hub: '',
      dob: '',
      healthPlanId: '',
      userId: '',
      status: 0,
    });
    onClose();
  };

  const statusClick = (val) => {
    setHoverStatus(undefined);
    setRequestData((prev) => ({
      ...prev,
      status: val,
    }));
  };

  const saveClick = async () => {
    let hasError = false;
    _.forEach(requestData, (val, key) => {
      if (!val && key !== 'status') {
        setRequestError((prev) => ({
          ...prev,
          [key]: 'Field is required',
        }));
        hasError = true;
      } else if (val && key === 'email' && !utils.isEmail(val)) {
        setRequestError((prev) => ({
          ...prev,
          [key]: 'Invalid email',
        }));
        hasError = true;
      }
    });

    if (hasError) {
      toast.error('Please correct all errors');
    } else {
      setSaveLoading(true);
      await dispatch(createPersonsRequest(requestData));

      setSaveLoading(false);
      closeModal();
    }
  };

  return (
    <Modal open={open} className={classes.modal_wrapper} onClose={closeModal}>
      <h2>Add new</h2>

      <div className={classes.add_person_wrapper}>
        <div className={classes.add_person_left}>
          <div className={classes.add_person_item}>
            <SelectWithSearch
              label="Heath plan"
              optionPathname="hubId"
              zIndex={31}
              optionKey="id"
              options={healthList}
              searchValue={searchHeath}
              onChange={onChangeHeathSearch}
              loading={searchLoading}
              error={requestError.healthPlanId}
              onSelectOption={(option, searchValue) => onChangeData('healthPlanId', option, searchValue)}
            />
          </div>

          <div className={classes.add_person_item}>
            <Select
              onChange={() => {
              }}
              label="Pipeline"
              currentOption="Persons"
              options={['Persons']}
              zIndex={31}
            />
          </div>

          <div className={classes.add_person_item}>
            <AssigneeSelect
              error={requestError.userId}
              assigneeId={+userId}
              onchange={({ id }) => onChangeData('userId', id)}
            />
          </div>

          <div className={classes.status_list}>
            <ul className={classes.status_list_wrapper}>
              {_.map(personStatusPosition, (val, key) => (
                <li
                  style={{
                    zIndex: `${count--}`,
                    order: val,
                  }}
                  key={val}
                  onMouseOver={() => setHoverStatus(val)}
                  onMouseOut={() => setHoverStatus(undefined)}
                  onClick={() => statusClick(val)}
                  className={`${classes.person_status} ${
                    hoverStatus >= val
                      ? classes.hover
                      : status >= val
                        ? classes.active
                        : ''}`}
                >
                  {hoverStatus === val && <p>{_.startCase(key)}</p>}
                </li>
              ))}
            </ul>
          </div>

        </div>

        <div className={classes.add_person_right}>
          <div className={classes.add_person_right_twens}>
            <div>
              <InputField
                type="text"
                label="First Name"
                value={firstName}
                error={requestError.firstName}
                onChange={(value) => onChangeData('firstName', value)}
              />
            </div>

            <div>
              <InputField
                type="text"
                label="Last Name"
                value={lastName}
                error={requestError.lastName}
                onChange={(value) => onChangeData('lastName', value)}
              />
            </div>
          </div>

          {createPersonTemplate.map((c) => (
            c.path === 'dob'
              ? (
                <div key={c.label} className={classes.add_person_item}>

                  <DOBPicker
                    label={c.label}
                    date={requestData[c.path] || ''}
                    onChange={(date) => onChangeData(c.path, date)}
                    error={requestError[c.path]}
                    autoValidation={false}
                  />
                </div>
              )
              : (
                <div key={c.label} className={classes.add_person_item}>
                  <InputField
                    type="text"
                    label={c.label}
                    value={requestData[c.path]}
                    error={requestError[c.path]}
                    onChange={(value) => onChangeData(c.path, value)}
                    onKeyPress={(e) => onKeyPress(e, c.path)}
                    onPaste={(e) => onKeyPress(e, c.path, true)}
                  />
                </div>
              )
          ))}

          <div className={classes.add_person_right_twens}>
            <div>
              <InputField
                type="text"
                label="State"
                value={addressState}
                error={requestError.addressState}
                onChange={(value) => onChangeData('addressState', value)}
              />
            </div>

            <div>
              <InputField
                type="text"
                label="Zip Code"
                value={addressZipCode}
                error={requestError.addressZipCode}
                onChange={(value) => onChangeData('addressZipCode', value)}
              />
            </div>
          </div>

          <div className={classes.add_person_right_buttons}>
            <Button
              onClick={saveClick}
              title="Save"
              type="button"
              reverseColor
              loading={saveLoading}
              className={classes.add_person_right_button}
            />

            <Button
              onClick={closeModal}
              title="Cancel"
              type="button"
              clearButton
              className={classes.add_person_right_button}
            />
          </div>
        </div>
      </div>
    </Modal>
  );
};

CreatePersonModal.protoTypes = {
  open: PropTypes.bool,
  onClose: PropTypes.func,
};

CreatePersonModal.defaultProps = {
  open: false,
  onClose: () => {
  },
};

export default CreatePersonModal;
